import { tagListStore } from "stores/tag-list-store";
import { agentWithStatusStore } from "src/features/agent/agent-avatar-with-status/agent-with-status-global-store";
import { agentSettingsStore } from "stores/agent-settings-global-store";
import { connectedServiceStore } from "stores/connected-service-global-store";
import { sessionSettingsStore } from "stores/session-settings-global-store";
import { activeConversationCountStore } from "src/features/conversation/active-conversation-count/active-conversation-count-global-store";
import { unseenAgentNotificationCountStore } from "src/features/agent-notification/unseen-agent-notification-count/unseen-agent-notification-count-global-store";

tagListStore.noop();
agentWithStatusStore.noop();
agentSettingsStore.noop();
connectedServiceStore.noop();
sessionSettingsStore.noop();
activeConversationCountStore.noop();
unseenAgentNotificationCountStore.noop();
